import { createContext, useContext, useState, useCallback } from 'react';
import { ISearchUserContext, ISearchUserProvider } from './interfaces';

const SearchUserContext = createContext<ISearchUserContext | null>(null);

export const useSearchUserContext = () =>
  useContext(SearchUserContext) as ISearchUserContext;

const SearchUserProvider = ({ children }: ISearchUserProvider) => {
  const [focusOnSearchField, setFocusOnSearchField] = useState<boolean>(false);
  const [searchResultNumber, setSearchResultNumber] = useState<number>(0);

  const onFindTapHeader = useCallback(() => {
    setFocusOnSearchField(true);
  }, [setFocusOnSearchField]);

  const onBackHeader = useCallback(() => {
    setFocusOnSearchField(false);
  }, [setFocusOnSearchField]);

  return (
    <SearchUserContext.Provider
      value={{
        focusOnSearchField,
        onFindTapHeader,
        onBackHeader,
        searchResultNumber,
        setSearchResultNumber,
        setFocusOnSearchField,
      }}
    >
      {children}
    </SearchUserContext.Provider>
  );
};

export default SearchUserProvider;
